<div class="fs-2 success with-close" mat-dialog-title>
    Modification validée
    <i class="fa fa-close" (click)="onNoClick()" aria-hidden="true"></i>
</div>
<div mat-dialog-content>
    <b>Votre modification est bien enregistrée</b>
    <p>
        La modification de votre forfait sera effective dès votre prochain renouvellement.
    </p>
</div>
<div mat-dialog-actions>
    <button type="button" (click)="onNoClick()" class="btn btn-outline w-100">
        Fermer
    </button>
</div>
